import { Secondary, SvgIcon, Text, TextLink } from '@cinch-labs/design-system'
import { useSitesToShow } from '../../find-a-site.hook'
import { SiteCard } from '../site-card/site-card'
import { Map } from '../map/map'
import { OverlayMap } from '../map/overlay-map'
import { useRef, useState } from 'react'
import styles from './site-results.module.css'
import { FindASiteProps, ListedSite } from '../../find-a-site'
import { Coordinates } from '@cinch-labs/sites-sdk'

interface SiteResultsProps {
  sites: ListedSite[]
  mobileSelectedSite?: ListedSite
  onSiteCardClick: FindASiteProps['onSiteCardClick']
  content: FindASiteProps['content']
  userLocation: {
    postcode: string
    coordinates: Coordinates
  }
}

export const SiteResults = ({
  sites,
  mobileSelectedSite,
  onSiteCardClick,
  content,
  userLocation,
}: SiteResultsProps) => {
  const { sitesToShow, showMoreSites } = useSitesToShow(sites, content)
  const [selectedSite, setSelectedSite] = useState<ListedSite | undefined>()
  const [mobileMapViewIsOpen, setMobileMapViewIsOpen] = useState(false)
  const siteListRef = useRef<HTMLDivElement>(null)

  const scrollCardIntoView = (index: number) => {
    if (siteListRef.current) {
      siteListRef.current.scrollTo({ behavior: 'smooth', top: 280 * index })
    }
  }

  return (
    <>
      <div className={styles.listHeading}>
        <Text>Choose one option</Text>
        <TextLink
          onClick={() => setMobileMapViewIsOpen(true)}
          className={styles.viewOnMapLink}
        >
          <Text fontSizeFixed="m">
            <SvgIcon name="location" />
            View on map
          </Text>
        </TextLink>
      </div>
      <div className={styles.resultsContainer}>
        <div className={styles.listAndMapContainer}>
          <div className={styles.siteListContainer} ref={siteListRef}>
            {sitesToShow.map((site) => (
              <SiteCard
                key={site.siteId}
                site={site}
                onClick={onSiteCardClick}
                postcode={userLocation.postcode}
                isSelected={site.siteId === selectedSite?.siteId}
                buttonText={content.siteCardButtonText}
                showCinchStoresFreeOnCard={content.showCinchStoresFreeOnCard}
              />
            ))}
          </div>

          <div className={styles.mapContainer}>
            <Map
              sites={sitesToShow}
              selectedSite={selectedSite}
              setSelectedSite={setSelectedSite}
              location={{
                ...userLocation.coordinates,
                postcode: userLocation.postcode,
              }}
              onMarkerClick={scrollCardIntoView}
            />
          </div>
        </div>
        {sitesToShow.length < sites.length && (
          <div className={styles.showMoreButton}>
            <Secondary isFullWidth onClick={showMoreSites}>
              {content.showMoreButtonText}
            </Secondary>
          </div>
        )}
      </div>

      {mobileMapViewIsOpen && mobileSelectedSite && (
        <OverlayMap
          sites={sitesToShow}
          selectedSite={mobileSelectedSite}
          onClose={() => setMobileMapViewIsOpen(false)}
          onSiteCardClick={onSiteCardClick}
          location={{
            ...userLocation.coordinates,
            postcode: userLocation.postcode,
          }}
          buttonText={content.siteCardButtonText}
          showCinchStoresFreeOnCard={content.showCinchStoresFreeOnCard}
        />
      )}
    </>
  )
}
